module.exports = __webpack_public_path__ + "img/yellow-pin.51f74a66.png";